module.exports = __webpack_public_path__ + "media/Werbung_Leiner.8123c471.mp3";